<template>
  <div slot-scope="{ form, methods }" class="space-y-6">

    <div class="flex items-center p-6 text-pink-800 bg-pink-100 rounded">
      <fa :icon="['far', 'info-circle']" size="lg" class="mr-4 opacity-75" />
      <div>
        <strong>IMPORTANT:</strong> In order to properly detect panic buttons, ensure the message sent on the panic button input event includes the word "panic" somewhere.
      </div>
    </div>

    <vehicles-card :form="form" :methods="methods" />

    <area-card :form="form" :methods="methods" />

    <schedule-card :form="form" :methods="methods" />
    
    <contacts-card :form="form" :methods="methods" />

    <monitor-card :form="form" :methods="methods" />

  </div>
</template>

<script>
  import AreaCard from '@/views/automations/components/AreaCard'
  import ContactsCard from '@/views/automations/components/ContactsCard'
  import DriverDeviceCard from '@/views/automations/components/DriverDeviceCard'
  import MonitorCard from '@/views/automations/components/MonitorCard'
  import ScheduleCard from '@/views/automations/components/ScheduleCard'
  import VehiclesCard from '@/views/automations/components/VehiclesCard'

  export default {
    name: 'PanicButtonNotification',
    
    components: { 
      AreaCard,
      ContactsCard,
      DriverDeviceCard,
      MonitorCard,
      ScheduleCard,
      VehiclesCard
    },

    props: ['form', 'methods']
  }
</script>